import ReactPlayer from 'react-player';
import { QuestionThinkAndReveal } from '../../../questiontype/ThinkAndReveal/QuestionThinkAndReveal';
import { QuestionAssociate } from '../../../questiontype/Associate/QuestionAssociate';
import { QuestionCycleEnd } from '../../../questiontype/CycleEnd/QuestionCycleEnd';
import { QuestionMemorizePoints } from '../../../questiontype/MemorizePoints/QuestionMemorizePoints';
import { AspectDraggable } from '../../../classes/aspect/modules/AspectDraggable';
import { QuestionKnowAWord } from '../../../questiontype/KnowAWord/QuestionKnowAWord';
import { AssociateOption } from '../../../questiontype/Associate/AssociateOption/AssociateOption';
import { Association } from '../../../questiontype/Associate/Association/Association';
import { ActorIntersect } from '../../../classes/actor/modules/ActorIntersect';
import { QuestionSortable } from '../../../questiontype/Sortable/QuestionSortable';
import { QuestionMultiSelect } from '../../../questiontype/MultiSelect/QuestionMultiSelect';
import { SelectOption } from '../../../questiontype/MultiSelect/SelectOption/SelectOption';
export class PackageRareClasses {
    QuestionThinkAndReveal = QuestionThinkAndReveal;
    QuestionAssociate = QuestionAssociate;
    QuestionCycleEnd = QuestionCycleEnd;
    QuestionSortable = QuestionSortable;
    QuestionMemorizePoints = QuestionMemorizePoints;
    AspectDraggable = AspectDraggable;
    ReactPlayer = ReactPlayer;
    QuestionKnowAWord = QuestionKnowAWord;
    QuestionMultiSelect = QuestionMultiSelect;
    AssociateOption = AssociateOption;
    SelectOption = SelectOption;
    Association = Association;
    ActorIntersect = ActorIntersect;
}
